export default __webpack_public_path__ + "static/grenette-italic-pro-f306c90bf795846159008c2943ebe4b7.eot";